import type { EncodingPreference, QualityMode } from "@srd/shared";

export function QualityControls(props: {
  qualityMode: QualityMode;
  encodingPreference: EncodingPreference;
  maxFps: number;
  maxWidth: number;
  disabled: boolean;
  onChange: (next: {
    qualityMode: QualityMode;
    encodingPreference: EncodingPreference;
    maxFps: number;
    maxWidth: number;
  }) => void;
  onApply: () => void;
}) {
  return (
    <div className="panel quality-panel">
      <h2>Quality</h2>
      <div className="row">
        <label>
          UX mode
          <select
            disabled={props.disabled}
            value={props.qualityMode}
            onChange={(e) =>
              props.onChange({
                qualityMode: e.target.value as QualityMode,
                encodingPreference: props.encodingPreference,
                maxFps: props.maxFps,
                maxWidth: props.maxWidth,
              })
            }
          >
            <option value="auto">auto</option>
            <option value="ui_sharp">UI sharp</option>
            <option value="ui_save_bandwidth">UI save bandwidth</option>
            <option value="video_smooth">Video smooth</option>
          </select>
        </label>
        <label>
          Encode preference
          <select
            disabled={props.disabled}
            value={props.encodingPreference}
            onChange={(e) =>
              props.onChange({
                qualityMode: props.qualityMode,
                encodingPreference: e.target.value as EncodingPreference,
                maxFps: props.maxFps,
                maxWidth: props.maxWidth,
              })
            }
          >
            <option value="ui_tile">ui_tile</option>
            <option value="h264_hw">h264_hw</option>
            <option value="auto">auto</option>
          </select>
        </label>
        <label>
          Max FPS
          <input
            type="number"
            min={1}
            max={60}
            disabled={props.disabled}
            value={props.maxFps}
            onChange={(e) =>
              props.onChange({
                qualityMode: props.qualityMode,
                encodingPreference: props.encodingPreference,
                maxFps: Number(e.target.value),
                maxWidth: props.maxWidth,
              })
            }
          />
        </label>
        <label>
          Max width
          <input
            type="number"
            min={640}
            max={3840}
            step={80}
            disabled={props.disabled}
            value={props.maxWidth}
            onChange={(e) =>
              props.onChange({
                qualityMode: props.qualityMode,
                encodingPreference: props.encodingPreference,
                maxFps: props.maxFps,
                maxWidth: Number(e.target.value),
              })
            }
          />
        </label>
        <button
          type="button"
          className="primary"
          disabled={props.disabled}
          onClick={props.onApply}
        >
          Apply
        </button>
      </div>
    </div>
  );
}
